<template>
  <div class="thank-you-page">
    <div class="thank-you-card">
      <div class="icon">✔️</div>
      <h1>Tes Selesai!</h1>
      <p>Terima kasih telah menyelesaikan tes. Jawaban Anda telah berhasil kami rekam.</p>
      <button @click="backToDashboard">Kembali ke Dashboard</button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';

const router = useRouter();
const route = useRoute(); // Gunakan useRoute untuk mengakses parameter
const score = ref(0);

onMounted(() => {
  // Ambil skor dari query parameter di URL
  score.value = route.query.score || 0;
});

const backToDashboard = () => {
  router.push({ name: 'TestDashboard' });
};
</script>

<style scoped>
.thank-you-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f0f2f5;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.thank-you-card {
  text-align: center;
  background: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  max-width: 450px;
  width: 90%;
}
.icon {
  font-size: 40px;
  color: #28a745;
  width: 70px;
  height: 70px;
  line-height: 70px;
  border: 3px solid #28a745;
  border-radius: 50%;
  margin: 0 auto 20px auto;
}
h1 {
  margin-bottom: 10px;
  color: #333;
}
p {
  color: #555;
  line-height: 1.6;
}
button {
  margin-top: 25px;
  padding: 12px 24px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1em;
  font-weight: 500;
  transition: background-color 0.2s;
}
button:hover {
  background-color: #2980b9;
}

/* STYLE BARU UNTUK KOTAK SKOR */
.score-card {
  border: 1px solid #e0e0e0;
  background-color: #f8f9fa;
  padding: 20px;
  margin: 30px auto 0;
  max-width: 200px;
  border-radius: 10px;
}
.score-card p {
  margin: 0 0 5px 0;
  font-size: 0.9em;
  color: #666;
}
.score-card h2 {
  margin: 0;
  font-size: 3em;
  color: #2c3e50;
}
</style>